import api from './api';

const pricingService = {
  /**
   * Get all pricing plans from the API
   * @returns {Promise<Array>} Promise resolving to an array of pricing plans
   */
  getPricingPlans: async () => {
    try {
      const response = await api.get('/pricing/plans');
      return response.data.plans;
    } catch (error) {
      console.error('Error fetching pricing plans:', error);
      throw error;
    }
  },
  
  /**
   * Get annual pricing for a specific plan from the API
   * @param {string} planSlug - Plan slug (e.g., 'standard')
   * @returns {Promise<Object>} Promise resolving to annual pricing details
   */
  getAnnualPricing: async (planSlug) => {
    if (!planSlug || planSlug === 'free') {
      return null;
    }
    
    try {
      const response = await api.get(`/pricing/annual/${planSlug}`);
      return response.data.annualPricing;
    } catch (error) {
      console.error(`Error fetching annual pricing for ${planSlug}:`, error);
      throw error;
    }
  },
  
  /**
   * Subscribe to a plan
   * @param {string} planSlug - Plan slug to subscribe to
   * @returns {Promise<Object>} Promise resolving to subscription details
   */
  subscribeToPlan: async (planSlug) => {
    try {
      const response = await api.post('/pricing/subscribe', { plan: planSlug });
      return response.data;
    } catch (error) {
      console.error('Error subscribing to plan:', error);
      throw error;
    }
  }
};

export default pricingService;